





















































































































































import BaseComponent from '@/components/base-component.vue';
import CancellationReasons from '@/components/parameters/cancellation-reasons/list.vue';
import ParametersFormExpirationTime from '@/components/parameters/form/expiration-time.vue';
import ParametersFormPatientClassification from '@/components/parameters/form/patient-classification.vue';
import ParametersFormProportionCalN from '@/components/parameters/form/proportion-cal-n.vue';
import ParametersFormSchedulingDays from '@/components/parameters/form/scheduling-days.vue';
import ParametersFormTranscriptionApprove from '@/components/parameters/form/transcription-approve.vue';
import ParametersFormTranscriptionMinChecks from '@/components/parameters/form/transcription-min-checks.vue';
import InfusionTime from '@/components/parameters/infusion-time/list.vue';
import ParametersOverrideFilterList from '@/components/parameters/override/filter-list.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import ParameterModel from '@/models/parameter-model';
import * as service from '@/services/parameters';
import {
  CANCELLATION_REASON,
  EXPIRATION_TIME,
  INFUSION_TIME,
  PARAMETERS_VALUE_TYPE_BOOLEAN,
  PARAMETERS_VALUE_TYPE_FILE,
  PARAMETERS_VALUE_TYPE_INTEGER, PARAMETERS_VALUE_TYPE_LIST_TEXT, PARAMETERS_VALUE_TYPE_PASSWORD, PARAMETERS_VALUE_TYPE_TEXT, PATIENT_CLASSIFICATION_PARAM,
  PROPORTION_CAL_N, SCHEDULING_DAYS,
  TEMPO_CANCEL_PROSPEC, TRANSCRIPTION_APPROVE_PARAM,
  TRANSCRIPTION_MIN_CHECKS
} from '@/settings/consts/parameters-keys';
import {
  OVERRIDE_WEIGHT_CLIENT, REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_DOCTOR,
  REFERENCE_TYPE_TEAM
} from '@/settings/consts/rules-engine';
import { cloneDeep } from 'lodash';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ParametersFormBooleanListType from '../form/boolean-list-type.vue';
import ParametersFormBooleanType from '../form/boolean-type.vue';
import ParametersFormFileType from '../form/file-type.vue';
import ParametersFormIntegerType from '../form/integer-type.vue';
import ParametersFormListTextType from '../form/list-text-type.vue';
import ParametersFormPasswordType from '../form/password-type.vue';

@Component({
  components: {
    ParametersFormPatientClassification,
    ParametersFormSchedulingDays,
    ParametersFormTranscriptionApprove,
    ParametersFormTranscriptionMinChecks,
    PermissionAuth,
    ParametersOverrideFilterList,
    ParametersFormExpirationTime,
    ListMessages,
    InfusionTime,
    CancellationReasons,
    ParametersFormProportionCalN,
    ParametersFormBooleanType,
    ParametersFormBooleanListType,
    ParametersFormIntegerType,
    ParametersFormFileType,
    ParametersFormPasswordType,
    ParametersFormListTextType
  },
})
export default class ParametersOverrideList extends BaseComponent {
  @Prop(ParameterModel)
  public parameter?: ParameterModel;
  @Prop()
  public filter?: any;
  @Prop({
    default: true,
  })
  public showAddButton: boolean;  

  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public parameterFormIsEdit: boolean = false;
  public parameterToEdit: any = null;

  public referencesTypes: any = {
    client: REFERENCE_TYPE_CLIENT,
    team: REFERENCE_TYPE_TEAM,
    doctor: REFERENCE_TYPE_DOCTOR,
  };

  public parametersTypes: any = {
    schedulingDays: SCHEDULING_DAYS,
    transcriptionApprove: TRANSCRIPTION_APPROVE_PARAM,
    transcriptionMinChecks: TRANSCRIPTION_MIN_CHECKS,
    patientClassification: PATIENT_CLASSIFICATION_PARAM,
    cancelationReasons: CANCELLATION_REASON,
    expirationTime: EXPIRATION_TIME,
    infusionTime: INFUSION_TIME,
    proportionCalN: PROPORTION_CAL_N,
    tempoCancelProspec: TEMPO_CANCEL_PROSPEC
  };

  public referencesTypesList: any[] = [
    {
      id: 'CLIENTE',
      value: 'Unidade',
    },
    {
      id: 'MEDICO',
      value: 'Médico',
    },
    {
      id: 'TIME',
      value: 'Time',
    },
  ];

  public headers: any = [
    {
      text: 'Unidade / Cliente',
      value: 'props.item.unidade.nome',
      sortable: false,
    },
    { text: 'Referência', value: 'referencia', sortable: false },
    { text: 'Tipo de Referência', value: 'hierarquia', sortable: false },
    { text: 'Ações', value: 'name', sortable: false, align: 'right' },
  ];

  public data: ParameterModel[] = [];

  @Watch('filter', { deep: true })
  public onFilterChange(filter): void {
    this.filter = filter;
    this.load();
  }
  public load(): void {
    this.getParametersOverrides();     
  }

  @Watch('parameter')
  public onParameterChange(parameter): void {
    if (parameter) {
      this.load();
    }
  }

  public hierarchy(type): string {
    if (type) {
      const foundType = this.referencesTypesList.find((x) => x.id === type);
      return !!foundType ? foundType.value : '-';
    }
    return '-';
  }

  private isParameterBooleanType(){
    return this.parameter && this.parameter.valores && this.parameter.valores.length == 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_BOOLEAN;
  }

  private isParameterBooleanListType(){
    return this.parameter && this.parameter.valores && this.parameter.valores.length > 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_BOOLEAN;
  }

  private isParameterIntegerType() {
    return this.parameter && this.parameter.valores && this.parameter.valores.length == 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_INTEGER;
  }

  private isParameterFileType() {
    return this.parameter && this.parameter.valores && this.parameter.valores.length == 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_FILE;
  }

  private isParameterPasswordType() {
    return this.parameter && this.parameter.valores && this.parameter.valores.length == 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_PASSWORD;
  }

  private isParameterTextListType() {
    return this.parameter && this.parameter.valores && 
    ( 
      (this.parameter.valores.length > 1 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_TEXT) 
      || 
      (this.parameter.valores.length > 0 && this.parameter.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_LIST_TEXT)
    );
  }

  public newParameter() {
    this.formOpen = true;

    const parameter = cloneDeep(this.filter.parameter);
    const uuidv4 = require('uuid/v4');
    const values = parameter.valores.map((item) => {
      item.id = uuidv4();
      item.isNew = true;
      return item;
    });

    const payload = {
      unidade: null,
      sobrescreve: {
        id: parameter.id,
      },
      referenciaHierarquia: '',
      hierarquiasPossiveis: parameter.hierarquiasPossiveis,
      hierarquia: REFERENCE_TYPE_CLIENT,
      nome: parameter.nome,
      tipoParametro: parameter.tipoParametro,
      valores: values,
      peso: OVERRIDE_WEIGHT_CLIENT,
    };

    this.parameterToEdit = new ParameterModel(payload);

    this.parameterFormIsEdit = true;
  }

  public closeForm() {
    this.formOpen = false;
    this.parameterToEdit = new ParameterModel();
    this.parameterFormIsEdit = false;
    this.load();
    resetModalScroll();
  }

  public onDeleteItem(item: any) {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      service.deleteParameter(item.id).subscribe(
        (data) => {
          this.loader.stop();
          this.load();
        },
        (err) => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao deletar a regra', 'error');
        },
      );
    };

    this.dialog.show(
      'error',
      'Excluir Regra',
      'Tem certeza que deseja excluir esta regra?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public onEditItem(item: any) {
    this.loadIntoForm(item);
  }

  public loadIntoForm(item: any, clone: boolean = false): void {
    this.loader.start('Carregando regra...');
    service.getParameter(item.id).subscribe(
      (data) => {
        this.loader.stop();
        if (!!clone) {
          data.id = null;
        }
        const payload = { ...data };
        this.parameterToEdit = new ParameterModel(payload);
        this.parameterFormIsEdit = !clone;
        this.formOpen = true;
      },
      (err) => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar a regra', 'error');
      },
    );
  }

  private getParametersOverrides(): void {
    this.data = [];

    if (
      !this.filter.parameter &&
      !this.filter.clientUnit &&
      !this.filter.team &&
      !this.filter.doctor
    ) {
      return;
    }

    const filter = {
      idParametro: !!this.filter.parameter ? this.filter.parameter.id : null,
      idUnidade: !!this.filter.clientUnit ? this.filter.clientUnit.id : null,
      idTime: !!this.filter.team ? this.filter.team : null,
      idMedico: this.filter.doctor  ? this.filter.doctor : null,
    };

    this.loading = true;
    this.error = false;
    service.getParametersOverrides(filter).subscribe(
      (data) => {
        this.data = data.map((item) => new ParameterModel(item));
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
